import { motion } from "framer-motion";
import { useContent } from "../../i18n/useContent";
import { Icon } from "../ui/Icons";
import { Reveal, RevealGroup, revealItemVariants } from "../ui/Reveal";
import CoverageMap from "./CoverageMap";
import "./Coverage.css";

function Coverage() {
  const { coverage } = useContent();

  return (
    <section id="cobertura" className="section section--dark coverage">
      <div className="container coverage-inner">
        <div className="coverage-grid">
          <div className="coverage-text">
            <Reveal className="section-head">
              <span className="eyebrow on-dark">{coverage.eyebrow}</span>
              <h2 className="section-title">{coverage.title}</h2>
              <p className="section-lead">{coverage.lead}</p>
            </Reveal>

            <RevealGroup className="coverage-states" stagger={0.03} delay={0.15}>
              {coverage.states.map((state) => (
                <motion.span className="coverage-pill" variants={revealItemVariants} key={state}>
                  {state}
                </motion.span>
              ))}
            </RevealGroup>

            <Reveal className="coverage-ports-section" delay={0.25}>
              <span className="coverage-block-label">{coverage.portsLabel}</span>
              <div className="coverage-ports">
                {coverage.ports.map((port) => (
                  <span className="coverage-port-badge" key={port}>
                    <Icon name="mapPin" size={18} />
                    {port}
                  </span>
                ))}
              </div>
              <div className="coverage-expansion">
                <span className="coverage-pulse" aria-hidden="true">
                  <span className="coverage-pulse-dot" />
                </span>
                <span className="coverage-expansion-text">{coverage.expansion}</span>
              </div>
            </Reveal>
          </div>

          <Reveal className="coverage-map-wrap" delay={0.2} y={28}>
            <CoverageMap />
            <p className="coverage-map-caption">
              {coverage.mapCaption}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default Coverage;
